import { render, staticRenderFns } from "./Filter.vue?vue&type=template&id=33601a08"
import script from "./Filter.vue?vue&type=script&lang=js"
export * from "./Filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33601a08')) {
      api.createRecord('33601a08', component.options)
    } else {
      api.reload('33601a08', component.options)
    }
    module.hot.accept("./Filter.vue?vue&type=template&id=33601a08", function () {
      api.rerender('33601a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/components/Filter.vue"
export default component.exports